
import { userService } from '../_services/user.service';
import { alertActions } from './alert.actions';
import { userConstants as constants } from '../_constants/user.constants';

export const userActions = {
  setPage,
  retrieveUsers,
  setCurrentUser,
  getCurrentUser
};

function setPage(page) {
  return { type: constants.USERS_SET_PAGE, page }
}

function setCurrentUser(user) {
  return { type: constants.SET_CURRENT_USER, user }
}

function getCurrentUser() {
  return dispatch => {

    userService.getUser()
      .then(response => {
        localStorage.setItem('user', JSON.stringify(response.data));
        dispatch(userActions.setCurrentUser(response.data));
      });
  }
}

function retrieveUsers(page = 1, params = {}) {
  return dispatch => {
    dispatch(request());

    userService.retrieveUsers(page, params)
      .then((users) => {
        dispatch(success(users));
      })
      .catch(() => {
        dispatch(failure());

        dispatch(alertActions.error("Could not retrieve the users at this time. Please try again."));
      });
  }

  function request() { return { type: constants.USERS_RETRIEVE_REQUEST } }
  function success(users) { return { type: constants.USERS_RETRIEVE_SUCCESS, users } }
  function failure() { return { type: constants.USERS_RETRIEVE_FAILURE } }
}
